module.exports = __webpack_public_path__ + "static/media/Cap30Gb.b6cf94d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/Cap30Gb.svg
// module id = 111
// module chunks = 0